export default __webpack_public_path__ + "static/media/spinner.21a2ee25.gif";